import React from "react";
import { Scale, Infinity as InfinityIcon, Award } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ValoriProfessionali() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const values = [{
    title: "Etica",
    icon: Scale,
    description: "Operiamo con assoluta trasparenza e integrità, ponendo la deontologia al centro di ogni strategia legale. La fiducia del cliente è il nostro asset fondamentale, custodito con rigore e riservatezza in ogni fase del mandato.",
    offset: "lg:mt-0"
  }, {
    title: "Continuità",
    icon: InfinityIcon,
    description: "Garantiamo un'assistenza costante nel tempo, affiancando le imprese in ogni fase della loro evoluzione. Costruiamo relazioni solide e durature che ci permettono di comprendere a fondo le dinamiche e le necessità aziendali.",
    offset: "lg:mt-16"
  }, {
    title: "Specializzazione",
    icon: Award,
    description: "Offriamo competenze verticali in diritto civile e commerciale. Un approccio tecnico e mirato che assicura soluzioni precise per contrattualistica d'impresa, operazioni societarie straordinarie e negoziazioni complesse.",
    offset: "lg:mt-32"
  }];
  return <section id="valori-professionali" ref={ref} className="dark text-foreground py-24 px-6 overflow-hidden !bg-[hsl(238,100%,85%)] md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 md:mb-24 text-center lg:text-left">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-sans font-light tracking-tight text-foreground mb-6">
            I Nostri Valori
          </h2>
          <p className="max-w-2xl text-lg leading-relaxed !text-[hsl(0,0%,0%)]">
            I pilastri su cui fondiamo la nostra pratica legale, garantendo eccellenza e dedizione in ogni incarico.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 items-start">
          {values.map((value, i) => <div key={i} data-index={i} className={cn("transition-all duration-1000 ease-out", value.offset, isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
          transitionDelay: `${i * 200}ms`
        }}>
              <Card className="text-card-foreground flex flex-col gap-6 rounded-xl py-6 border-border/50 shadow-2xl transition-shadow duration-500 h-full !bg-[hsl(239,53%,69%)] hover:shadow-[var(--primary)]/10">
                <CardHeader className="pb-4">
                  <div className="mb-6 inline-flex items-center justify-center size-14 rounded-full bg-primary/10 text-primary ring-1 ring-primary/20">
                    <value.icon className="size-7" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-2xl font-sans font-bold tracking-tight text-foreground uppercase">
                    {value.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base leading-[1.8] !text-[hsl(0,0%,0%)]">
                    {value.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}